export default __webpack_public_path__ + "static/media/varanasi.e800e401.jpg";